import { css } from '@emotion/css';
import { useTranslation } from 'react-i18next';

import { font2 } from '^/constants/commonStyles';
import { capitalizeFirstLettersInWords } from '^/util/capitalizeFirstLetterInWords';

type ReservationDetailOfficeInfoCardProps = {
  title: string;
  officeName: string;
  officeAddress: string;
  officePhone: string;
  officeHours: string;
};

export const ReservationDetailOfficeInfoCard = ({
  title,
  officeName,
  officeAddress,
  officePhone,
  officeHours,
}: ReservationDetailOfficeInfoCardProps) => {
  const { t } = useTranslation();

  return (
    <div>
      <p className={font2.Caption1_Bold}>{title}</p>
      <div className="flex flex-col mt-[15px]">
        <div className="flex flex-col gap-2">
          <p className={font2.Caption1_Light}> {t(`location_name.${officeName}`)}</p>
          <div
            className={css`
              border-radius: 5px;
              gap: 5px;
              padding: 12px;
              background-color: #f2f2f2;
            `}
          >
            <div className="w-full flex">
              <span
                className={css`
                  display: block;
                  font-weight: 500;
                  font-size: 12px;
                  line-height: 16px;
                  color: #989ea4;
                  width: 60px;
                `}
              >
                주소
              </span>
              <span
                className={css`
                  font-weight: 400;
                  font-size: 12px;
                  line-height: 16px;
                  color: #34393e;
                `}
              >
                {capitalizeFirstLettersInWords(officeAddress)}
              </span>
            </div>
            <div className="w-full flex">
              <span
                className={css`
                  display: block;
                  font-weight: 500;
                  font-size: 12px;
                  line-height: 16px;
                  color: #989ea4;
                  width: 60px;
                `}
              >
                전화번호
              </span>
              <span
                className={css`
                  font-weight: 400;
                  font-size: 12px;
                  color: #34393e;
                  line-height: 16px;
                `}
              >
                {officePhone}
              </span>
            </div>
            <div className="w-full flex">
              <span
                className={css`
                  display: block;
                  font-weight: 500;
                  font-size: 12px;
                  line-height: 16px;
                  color: #989ea4;
                  width: 60px;
                `}
              >
                운영시간
              </span>
              <span
                className={css`
                  font-weight: 400;
                  font-size: 12px;
                  color: #34393e;
                  line-height: 16px;
                `}
              >
                {officeHours.replace('null', '__')}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
